// extracted by mini-css-extract-plugin
export default {"Title":"HeaderPage_Title__r1G+X","BoxTitle":"HeaderPage_BoxTitle__Yjl01"};